import { CurrencyPipe } from "@angular/common";
import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-money-column',
    template: `
    {{ value | currency : 'USD' }}
    `,
    standalone: true,
    imports: [
        CurrencyPipe
    ],
    styles: [
        `
        `
    ]
})

export class MoneyColumnComponent {
@Input() value: string = '';
}